import { Pipe, PipeTransform } from '@angular/core';
import { pick } from '@shared/functions';
import { TreeNode } from 'primeng/api';

@Pipe({
  name: 'selectedNodesText',
  standalone: false,
})
export class SelectedNodesTextPipe implements PipeTransform {
  transform(value: TreeNode | TreeNode[]): string {
    return Array.isArray(value) ? value.map(pick('label')).join(', ') : (value?.label ?? '');
  }
}
